import { useState } from "react";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";

/**
 * Parsuje JSON z kolumny "data" i renderuje jako listę klucz: wartość
 */
const renderDataValues = (dataJson) => {
  if (!dataJson) return "";
  try {
    const parsed = JSON.parse(dataJson);
    if (typeof parsed === "object" && parsed !== null) {
      return Object.entries(parsed)
        .map(([key, value]) => `${key}: ${value}`)
        .join(", ");
    }
    return String(parsed);
  } catch {
    return dataJson;
  }
};

const InformationHistoryTable = ({ data, onSortChange }) => {
  const [sortConfig, setSortConfig] = useState({ key: "DateAdd", direction: "desc" });
  const navigate = useNavigate();
  const { getResizeProps } = useColumnResize();

  const items = Array.isArray(data) ? data : [];

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const handleRowClick = (item) => {
    navigate(`/information/${item.informationId}`);
  };

  return (
    <div>
      <Table responsive striped bordered hover size="sm" className="custom-table">
        <thead>
          <tr>
            <th onClick={() => requestSort("TerminalDr")} {...getResizeProps()}>
              DR {getSortArrow("TerminalDr")}
            </th>
            <th onClick={() => requestSort("TerminalEx")} {...getResizeProps()}>
              EX {getSortArrow("TerminalEx")}
            </th>
            <th onClick={() => requestSort("Postcode")} {...getResizeProps()}>
              Kod {getSortArrow("Postcode")}
            </th>
            <th onClick={() => requestSort("CityName")} {...getResizeProps()}>
              Miejscowość {getSortArrow("CityName")}
            </th>
            <th onClick={() => requestSort("DateAdd")} {...getResizeProps()}>
              Data {getSortArrow("DateAdd")}
            </th>
            <th onClick={() => requestSort("UserName")} {...getResizeProps()}>
              Dodał {getSortArrow("UserName")}
            </th>
            <th onClick={() => requestSort("AcceptUserName")} {...getResizeProps()}>
              Zaakceptował {getSortArrow("AcceptUserName")}
            </th>
            <th {...getResizeProps()}>Wartości</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr
                key={`${item.id}-${index}`}
                onClick={() => handleRowClick(item)}
                style={{
                  cursor: "pointer",
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.closest("tr").style.backgroundColor = "#f8f9fa")}
                onMouseLeave={(e) => (e.target.closest("tr").style.backgroundColor = "")}
              >
                <td>{item.terminalDr}</td>
                <td>{item.terminalEx}</td>
                <td>{item.postcode}</td>
                <td>{item.cityName}</td>
                <td>{item.dateAdd}</td>
                <td>{item.userName}</td>
                <td>{item.acceptUserName}</td>
                <td style={{ maxWidth: "300px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {renderDataValues(item.data)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default InformationHistoryTable;
